<template>
    <div>
        <v-btn
            class="top_margin"
            small
            rounded
            title="Loading calibration images"
            v-if="loading || active_jobs.length > 0"
        >
            <v-icon x-small left>
                fa-solid fa-spinner fa-spin
            </v-icon>
            {{ $t('modellist.calibration') }}
        </v-btn>
        <v-btn
            class="top_margin"
            download
            :href="download_href"
            small
            rounded
            title="Download calibration images"
            v-else-if="download_href"
        >
            <v-icon x-small left>
                fa-solid fa-download
            </v-icon>
            {{ $t('modellist.calibration') }}
        </v-btn>
        <v-btn
            class="top_margin"
            small
            rounded
            title="Generate calibration images"
            @click="start_calibration"
            v-else
            :disabled="!has_dataset"
        >
            <v-icon x-small left>
                fa-solid fa-images
            </v-icon>
            {{ $t('modellist.calibration') }}
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "ModelCalibrationDownload",
    props: {
        model: { required: true },
        files: { required: true },
    },
    data() {
        return {
            active_jobs: [],
            loading: true,
        };
    },
    computed: {
        has_dataset() {
            const training = this.model.training_set_asset_count;
            const validation = this.model.validation_set_asset_count;
            return (training && training > 0) || (validation && validation > 0);
        },
        calibration_file() {
            return (this.files || []).find((file) => {
                return file.name.indexOf('calibration_images') > -1;
            });
        },
        download_href() {
            if (!this.has_dataset || !this.calibration_file) {
                return null;
            }
            return this.calibration_file.path;
        },
    },
    watch: {
        active_jobs(new_jobs, old_jobs) {
            if ((old_jobs || []).length > 0 && (new_jobs || []).length === 0) {
                this.$emit('calibration-ready');
            }
        },
    },
    methods: {
        async start_calibration() {
            this.loading = true;
            await this.$api.job.start_calibration_images_job(this.model.id);
            this.load_calibration_jobs();
        },
        async load_calibration_jobs() {
            let jobs = await this.$api.job.get_calibration_jobs(this.model.id);
            jobs = (jobs || []).filter((job) => job.processed == 0);
            this.active_jobs = jobs;
            this.loading = false;
            if (this.active_jobs.length > 0) {
                window.setTimeout(() => this.load_calibration_jobs(), 3000);
            }
        },
    },
    mounted() {
        this.load_calibration_jobs();
    },
};
</script>

<style scoped>
.top_margin {
    margin-top: 5px;
}
</style>
